<template>
    <b-card no-body>

        <b-modal id="create-or-update-contact" :title="['İletişim Bilgileri',contact.CariKod || null].join(' - ')" no-close-on-esc no-close-on-backdrop>
            <customer-account-create-or-update-contact v-model="contact"></customer-account-create-or-update-contact>
            <template #modal-footer><v-executer :loading="loading" text="Kaydet" :action="createOrUpdateContact"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    search
                    :initial-per-page="10"
                    pagination="server"
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import { NetsisApi } from '@/api/netsis'
import CustomerAccountCreateOrUpdateContact from './components/CustomerAccountCreateOrUpdateContact.vue'
export default {
    components:{
        BCard,
        CustomerAccountCreateOrUpdateContact
    },
    data() {
        return {
            fields:[
                {name:"Cari Kodu",key:"CariKod",sortKey:'CARI_KOD',thClass:'w-10',sortable:true},
                {name:"Cari İsmi",key:"CariIsim",sortKey:'CARI_ISIM',thClass:'w-25',sortable:true},
                {name:"Plasiyer",key:"PlasiyerFullName",thClass:'w-15',sortable:false},
                {name:"Alacak (TL)",key:"Alacak",thClass:'w-10',sortable:false,component:true, componentOptions:{ name:'customer/CustomerCreditForList' },tdClass:"text-nowrap text-right"},
                {name:"Kalan Borç (TL)",key:"Borc",thClass:'w-10',sortable:false,component:true, componentOptions:{ name:'customer/CustomerDebtForList' },tdClass:"text-nowrap text-right"},
                {name:"Bakiye (TL)",key:"Bakiye",thClass:'w-10',sortable:false,component:true, componentOptions:{ name:'customer/CustomerBalanceForList' },tdClass:"text-nowrap text-right"},
                {name:"Telefon",key:"CariTel",thClass:'w-10',sortable:false},
                {name:"E-Posta",key:"CariEmail",thClass:'w-10',sortable:false},
                {name:"GLN Kodu",key:"GlnKod",thClass:'w-10',sortable:false},

            ],
            buttons:[
                { text:"Detay",key:"detail",icon:"EyeIcon",variant:"secondary",action:this.detail },
                { text:"Detayı Yeni Sekmede Aç",key:"detail-new-tab",icon:"ExternalLinkIcon",variant:"info",action:this.detailNewTab },
                { text:"İletişim Bilgileri",key:"contact",icon:"PhoneIcon",variant:"success",action:this.contactDetail },
            ],
            loading:false,
            contact:{
                CariKod:null,
                CariPhone:null,
                CariEmail:null,
                CariDeliveryPhone:null
            }
        }
    },
    methods:{
        clearForm(){
            this.contact.CariKod = null
            this.contact.CariPhone = null
            this.contact.CariEmail = null
            this.contact.CariDeliveryPhone = null
        },
        provider(data){
            return NetsisApi.CustomerAccountPaginationTable(data)
        },
        detail(item){
            this.$router.push({name:'customer-account-detail',params:{code:item.CariKod}})
        },
        detailNewTab(item){
            const route = this.$router.resolve({name:'customer-account-detail',params:{code:item.CariKod}})
            window.open(route.href,'_blank')
        },
        contactDetail(item){
            this.clearForm()
            this.contact.CariKod  = item.CariKod
            this.contact.CariPhone = item.CariTel
            this.contact.CariEmail = item.CariEmail
            this.contact.CariDeliveryPhone = item.CariDeliveryPhone
            this.$showModal('create-or-update-contact')
        },
        isValidEmail(email){
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
        },
        createOrUpdateContact(){
            let email = this.contact.CariEmail?.trim() || null
            if(email && !this.isValidEmail(email)){
                this.$alert('Lütfen geçerli bir e-posta adresi giriniz.','AlertTriangleIcon','warning')
                return
            }
            this.loading = true
            let data = {
                CariKod: this.contact.CariKod,
                CariPhone: this.contact.CariPhone?.replace('(','').replace(')','').replaceAll(/\s/g,'') || null,
                CariEmail: email,
                CariDeliveryPhone: this.contact.CariDeliveryPhone?.replace('(','').replace(')','').replaceAll(/\s/g,'') || null
            }
            NetsisApi.CustomerContact(data).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update-contact')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        }
    },
}
</script>
        

<style>

</style>